const LEFT_TO_RIGHT_ISOLATE = String.fromCodePoint(0x2066);
const POP_DIRECTIONAL_ISOLATE = String.fromCodePoint(0x2069);
/* Keeps "404" and the name on one line, so a narrow column never strands the number. */
const NO_BREAK_SPACE = String.fromCodePoint(0xa0);
/* "404 Creative" and "404 OS", also when someone typed them reversed. */
const BRAND = /\b404\s+(Creative|OS)\b|\b(Creative|OS)\s+404\b/g;

/** Keep the brand reading left to right inside Arabic text (ADR-0007). */
export function lockBrand(text: string): string {
  return text.replace(BRAND, (_match, name: string | undefined, reversed: string | undefined) => {
    const product = name ?? reversed ?? "Creative";
    return `${LEFT_TO_RIGHT_ISOLATE}404${NO_BREAK_SPACE}${product}${POP_DIRECTIONAL_ISOLATE}`;
  });
}
